import { combineReducers, configureStore, Reducer } from '@reduxjs/toolkit'
import { groupApi } from '../services/groupApi'
import { getPreloadedQueryState, PreloadOptions } from './preload'
import eligibilitySlice from './slices/eligibilitySlice'
import sheetsSlice from './slices/sheetsSlice'
import globalToastSlice from './slices/globalToastSlice'
import handledErrorSlice from './slices/handledErrorSlice'
import { errorHandlerMiddleware } from './middlewares/errorHandler'
import groupFormSlice from './slices/groupFormSlice'

// Create the root reducer separately so that we can extract the RootState type
const rootReducer: Reducer = combineReducers({
  [groupApi.reducerPath]: groupApi.reducer,
  sheets: sheetsSlice,
  globalToast: globalToastSlice,
  eligibility: eligibilitySlice,
  handledError: handledErrorSlice,
  groupForm: groupFormSlice,
})

// use a separate function for setting up the store to make testing easier
export const setupStore = ({
  preloadOptions,
}: {
  preloadOptions: PreloadOptions
}) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState: {
      [groupApi.reducerPath]: getPreloadedQueryState(preloadOptions),
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        groupApi.middleware,
        errorHandlerMiddleware,
      ),
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
